
import React from 'react';

// Common props interface for all icons
export interface IconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

// Timer icon (for Pomodoro)
export const TimerIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = "currentColor", 
  strokeWidth = 2,
  className = ""
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={className}
    >
      <line x1="10" x2="14" y1="2" y2="2" />
      <line x1="12" x2="12" y1="8" y2="14" />
      <circle cx="12" cy="14" r="8" />
    </svg>
  );
};

// Clock icon (for current task)
export const ClockIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = "currentColor", 
  strokeWidth = 2,
  className = ""
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={className}
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
};

// RotateCcw icon (for reset)
export const RotateCcwIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = "currentColor", 
  strokeWidth = 2,
  className = ""
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={className}
    >
      <path d="M3 2v6h6" />
      <path d="M3 8a9 9 0 1 0 2.83-6.36L3 8" />
    </svg>
  );
};

// The IconProps interface is already exported at the top of the file
// No need for a duplicate export at the bottom
